/**
 * NavigationBlocker — warns before browser tab close / refresh when there
 * are unsaved changes. In-app navigation is gated manually via
 * confirmNavigation() calls in form components.
 *
 * Note: useBlocker requires a data router (createBrowserRouter). Since this
 * app uses BrowserRouter we use the native beforeunload event instead.
 */

import { useEffect } from 'react';
import { useUnsavedChangesContext } from '@/contexts/UnsavedChangesContext';

export default function NavigationBlocker() {
  const { hasUnsavedChanges } = useUnsavedChangesContext();

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';   // triggers the browser's native "Leave site?" dialog
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  return null;
}
